import axios from "axios";
import { authHeaderJson, authHeaderTextPlainJsonPatch } from "../auth-header.service";

const getAdjustmentStructurePolinomy = (l_elements_id, l_indicadores_id, wHeader) => {
    return axios.post(`/api/Polinomio/polinomio/get_polinomio`,
        {
            l_elements_id: l_elements_id,
            l_indicadores_id: l_indicadores_id,
            wHeader: wHeader
        }, { headers: authHeaderJson() } );
};

const getAdjustmentCalculatePolinomy = (l_items, period) => {
    const data = JSON.stringify(l_items);
    const fecha_ep = encodeURIComponent(period)
    return axios.post(`/api/Polinomio/polinomio/calculate_polinomio?${fecha_ep}`, data, { headers: authHeaderJson() });
    //return axios.request({ method: 'post', maxBodyLength: Infinity, url: `/api/Polinomio/polinomio/calculate_polinomio?${fecha_ep}`, headers: authHeaderTextPlainJsonPatch(), data : data })
};

export {
    getAdjustmentStructurePolinomy,
    getAdjustmentCalculatePolinomy
}